"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CSPMonitor = /*#__PURE__*/function () {
  function CSPMonitor() {
    _classCallCheck(this, CSPMonitor);
  }

  _createClass(CSPMonitor, null, [{
    key: "register",

    /* istanbul ignore next */
    value: function register() {
      if (!('document' in global) || !document.addEventListener) {
        return;
      }

      if (CSPMonitor.shouldRegisterCSPMonitor) {
        if (!CSPMonitor.added) {
          document.addEventListener('securitypolicyviolation', CSPMonitor.listener);
          CSPMonitor.added = true;
        }
      }
    }
    /* istanbul ignore next */

  }, {
    key: "unregister",
    value: function unregister() {
      if (!('document' in global) || !document.removeEventListener) {
        return;
      }

      document.removeEventListener('securitypolicyviolation', CSPMonitor.listener);
      CSPMonitor.loggers = new Set();
      CSPMonitor.added = false;
    }
  }, {
    key: "disable",
    value: function disable() {
      CSPMonitor.shouldRegisterCSPMonitor = false;
      CSPMonitor.unregister();
    }
  }, {
    key: "addLogger",
    value: function addLogger(logger) {
      if (logger) {
        CSPMonitor.loggers.add(logger);
      }
    }
  }, {
    key: "removeLogger",
    value: function removeLogger(logger) {
      if (logger) {
        CSPMonitor.loggers.delete(logger);
      }
    }
  }]);

  return CSPMonitor;
}();

exports.default = CSPMonitor;
CSPMonitor.loggers = new Set();
CSPMonitor.shouldRegisterCSPMonitor = true;
CSPMonitor.added = false;
/* istanbul ignore next */

CSPMonitor.listener = function (event) {
  var message = 'Security Policy Violation\n' + "Blocked URI: ".concat(event.blockedURI, "\n") + "Violated Directive: ".concat(event.violatedDirective, "\n") + "Original Policy: ".concat(event.originalPolicy, "\n") + "Document URI: ".concat(event.documentURI, "\n") + "Source File: ".concat(event.sourceFile, "\n") + "Line No.: ".concat(event.lineNumber, "\n");

  var _iterator = _createForOfIteratorHelper(CSPMonitor.loggers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var logger = _step.value;
      logger.error(message);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (CSPMonitor.loggers.size === 0) {
    console.error(message);
  }
};